import Modal from "@src/components/UIElements/Modal";
import { getAwsAssets, hitHapticFeedback } from "@src/utils";
import { Image } from "@src/components/Image";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showApplyCouponBottomSheetAction } from "../../store/actions";
import { useTranslation } from "react-i18next";
import {
  applyCourseCouponAction,
  removeCourseCouponAction,
  setCouponCodeAction,
  getGraphCourseCouponsAction,
} from "@src/components/Tabs/Overview/store/actions";
import { useRouter } from "@src/lib/router";
import NoCouponScreen from "./NoCouponScreen";
import Loader from "@src/components/UIElements/Loader";
import DashBorder from "../../../UIElements/DashBorder";
import formatCouponExpiryDateTime from "@src/utils/formatCouponExpiryDateTime";
import 'intersection-observer';

const ApplyCouponBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // LIMIT
  let limit = 20;
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showApplyCouponBottomSheet
  );

  const graphCouponListData = useSelector(
    (state) => state?.overviewReducer?.graphCourseCouponListData
  );

  const graphCourseData = useSelector(
    (state) => state?.overviewReducer?.graphCourseData
  );

  const offset = useSelector(
    (state) => state?.overviewReducer?.graphCouponListOffset
  );

  const totalCount = graphCouponListData?.totalCount;
  const loading = useSelector(
    (state) => state?.overviewReducer?.graphCourseCouponListDataLoading
  );

  const studentCouponList = graphCouponListData?.coupons;

  const [inputCouponCode, changeCouponCodeValue] = useState("");

  let couponsAvailableCount = `${t(
    "components.bottomSheets.components.applyCouponBottomSheet.couponsAvailable",
    "Available Coupons"
  )} (${totalCount || 0})`;

  const router = useRouter();

  // console.log("+++offset", offset);
  const fetchMore = () => {
    // console.log("fetchingOffset", offset);

    dispatch(
      getGraphCourseCouponsAction({
        variables: {
          courseId: `${router.query.courseId}`,
          limit: 20,
          offset: offset + limit,
        },
      })
    );
  };

  const handleCouponApply = (coupon, i, throughInput, close) => {
    //fake logic

    // dispatch(applyCouponFakeLoading());

    if (throughInput) {
      coupon = { code: inputCouponCode };
    }

    dispatch(
      applyCourseCouponAction({
        variables: {
          courseId: router.query.courseId,
          code: coupon?.code,
        },
      })
    );

    dispatch(setCouponCodeAction({ coupon }));

    if (close) {
      dispatch(showApplyCouponBottomSheetAction(false));
    }
  };

  let appliedCoupon = graphCourseData?.appliedCoupon;

  useEffect(() => {
    if (appliedCoupon?.redeemId) {
      changeCouponCodeValue(appliedCoupon?.code);
    }
    // console.log("appliedCoupon+++", appliedCoupon);
  }, []);

  const handleCouponRemove = () => {
    sessionStorage.removeItem("APPLIEDCOUPON");
    dispatch(
      removeCourseCouponAction({
        variables: {
          code: appliedCoupon.code,
          redemptionId: appliedCoupon.redeemId,
        },
      })
    );
  };

  const multipleCouponsConditions = useSelector(
    (state) => state?.overviewReducer?.multipleCouponsConditions
  );

  //INFINITE SCROLL HANDLING
  const observer = React.useRef();

  const lastRowRef = React.useCallback(
    (element) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && offset + limit < totalCount) {
          // console.log("callbackoffset", offset);

          fetchMore();
        }
      });
      if (element) observer.current.observe(element);
    },
    [offset < totalCount, fetchMore, offset]
  );

  return (
    <Modal
      showModal={state}
      handleClose={() => {
        dispatch(showApplyCouponBottomSheetAction(false));
      }}
      header={
        <div className="couponModalHeader">
          <Image
            src={getAwsAssets("CouponList.svg", "Overview")}
            className="SVGCoupons"
            height="20px"
            width="20px"
            alt={t(
              "components.bottomSheets.components.applyCouponBottomSheet.couponlist",
              "couponlist"
            )}
          />
          <span className="couponModalHeader--title">
            {t(
              "components.bottomSheets.components.applyCouponBottomSheet.applyCoupons",
              "Apply Coupons"
            )}
          </span>
        </div>
      }
    >
      <div className="enterCoupon">
        <input
          className="enterCouponField"
          type="text"
          value={inputCouponCode}
          onChange={(e) => {
            changeCouponCodeValue(e.target.value.toUpperCase());
          }}
          placeholder={t(
            "components.bottomSheets.components.applyCouponBottomSheet.enterCouponCode",
            "Enter a coupon code"
          )}
        />

        <button
          // disabled={inputCouponCode.length > 3}
          style={{
            opacity: inputCouponCode?.length > 3 ? "1" : "0.4",
          }}
          className="enterCouponButton"
          onClick={() => {
            hitHapticFeedback();
            if (inputCouponCode?.length <= 3) return;
            if (appliedCoupon?.redeemId) {
              handleCouponRemove();
            } else {
              handleCouponApply({}, null, true);
            }

            // handleShowModal(false);
          }}
        >
          {!appliedCoupon?.redeemId
            ? t(
                "components.bottomSheets.components.applyCouponBottomSheet.apply",
                "APPLY"
              )
            : t(
                "components.bottomSheets.components.applyCouponBottomSheet.remove",
                "REMOVE"
              )}
        </button>
      </div>

      {multipleCouponsConditions == 3 ? (
        <NoCouponScreen />
      ) : (
        <div>
          <div className="CouponModalLabel2">{couponsAvailableCount}</div>
          {studentCouponList &&
            studentCouponList.map(({ coupon }, i) => {
              // console.log("coupon111", coupon.code);
              const expiryText = formatCouponExpiryDateTime(coupon?.endDateTime);

              return (
                <div
                  key={i}
                  className="couponModalDiv"
                  onClick={() => {
                    // this.handleCouponApply(couponList && couponList.coupon);
                    //applyCoupon
                  }}
                  {...(i === studentCouponList?.length - 1 && fetchMore
                    ? { ref: lastRowRef }
                    : {})}
                >
                  <div key={i} className="CouponListItem">
                    {coupon?.label ? (
                      <div className="CouponModalLabel">{coupon?.label}</div>
                    ) : (
                      ""
                    )}

                    <div className="CouponModalRow1">
                      {coupon?.name ? (
                        <div className="CouponModalName">{coupon?.name}</div>
                      ) : (
                        ""
                      )}
                      {expiryText ? (
                        <div className="CouponModalValid">
                          <span className="CouponModalValid--expire">
                            {t(
                              "components.tabs.overview.components.coupons.index.expiresOnText",
                              "Expires on"
                            )}{" "}
                            {expiryText}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <DashBorder />
                    <div className="CouponModalRow2">
                      {coupon?.code ? (
                        <div className="CouponModalCode">{coupon?.code}</div>
                      ) : (
                        ""
                      )}
                      <div
                        className="CouponModalLink"
                        onClick={() => {
                          hitHapticFeedback();
                          handleCouponApply(coupon, i, false);
                        }}
                      >
                        {t(
                          "components.bottomSheets.components.applyCouponBottomSheet.apply",
                          "APPLY"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {loading ? (
        <div className="CouponModalLoading">
          <Loader colored small />{" "}
        </div>
      ) : (
        ""
      )}
    </Modal>
  );
};

export default ApplyCouponBottomSheet;
